import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import './todo.scss';

const ToDoSection = ({ payload }) => {
  const { toDo } = payload;
  const { t } = useTranslation();

  if (!toDo) return null;

  return (
    <section className="toDo">
      <div className="toDo__container">
        <h2>{t(toDo.title)}</h2>
        {toDo.paragraphs?.map((p, index) => (
          <>
            <p key={index}>{t(p)}</p>
          </>
        ))}
        {toDo.cta && (
          <div className="flex__class--row">
            <a className="button--secondary" href={toDo.cta.href}>
              {t(toDo.cta.label)}
            </a>
          </div>
        )}
      </div>
    </section>
  );
};

export default ToDoSection;